exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-icon[data-v-2c41a5e6]{font-size:2.5em}.file-icon .icon-container[data-v-2c41a5e6]{height:1em;width:1em;background:#007bff;position:relative;border-radius:50%}.file-icon .icon-container .icon-element[data-v-2c41a5e6]{font-size:.5em;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c41a5e6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/file-elements/file-icon.vue
// module id = 83
// module chunks = 0